/** Preserve the catalog's music benefits while omitting its legacy MV counts. */
export function subscriptionFeatures(html = '', period = '') {
  const entries = html.replace(/<\s*\/?\s*(?:b|li|p)\b[^>]*>/gi, '\n').split(/\r?\n|\|/)
    .map(text => text.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').replace(/&amp;/g, '&').trim())
    .filter(Boolean);
  return [...new Set(entries.map(text => text
    .replace(/^(Generate\s+[\d,.]+\s+songs?)\s+or\s+[\d,.]+\s+(?:music\s+)?MVs?\b/i, '$1')
    .replace(/^((?:每[年月周週]生成|生成)[\d,.]+首歌曲)或[\d,.]+\s*(?:首)?(?:音乐|音樂)?(?:MV)?/i, '$1')
    .replace(/^(.*?[\d,.]+曲)または[\d,.]+曲?の?\s*(?:音楽)?MV/i, '$1')
    .replace(/^(.*?[\d,.]+曲)または[\d,.]+\s*MV/i, '$1')
    .replace(/^(.*?[\d,.]+곡)\s+또는\s+[\d,.]+곡(?:의\s+음악\s+mv)?\s*(생성)/i, '$1 $2')
    .replace(/^((?:Générez|Générer)\s+[\d,.]+\s+chansons?)\s+ou\s+[\d,.]+\s+(?:musiques?\s+MV|musiques?|MV)\b/i, '$1')
    .replace(/^(Genera\s+[\d,.]+\s+canciones?)\s+o\s+[\d,.]+\s+(?:mv\s+musicales|videos\s+musicales|MV)\b/i, '$1')
    // The German catalog has an English "thly" typo; the plan tag confirms its period.
    .replace(/^(Generate\s+[\d,.]+\s+songs?)\s+thly$/i, period === 'month' ? '$1 monthly' : '$&')
    .trim()).filter(text => !/^(?:generate\s+)?[\d,.]+\s*(?:music\s+)?(?:MVs?\b|music videos?|音乐视频|音樂影片|ミュージックビデオ|뮤직비디오)\s*(?:generations?|yearly|monthly|annually|annual)?$/i.test(text)))];
}

/** Translate recognized catalog copy without inferring or adding benefits. */
export function localizeSubscriptionFeature(text, translate) {
  const song = /^Generate\s+([\d,.]+)\s+songs?(?:\s+(monthly|yearly|annual|weekly))?$/i.exec(text);
  if (song) {
    const period = { monthly: 'month', yearly: 'year', annual: 'year', weekly: 'week' }[song[2]?.toLowerCase()];
    return translate('billing.benefitSongs' + (period ? '_' + period : ''), { count: song[1] });
  }
  const download = /^Download\s+([\d,.]+)\s+YT\s+MP3\s+or\s+MP4$/i.exec(text);
  if (download) return translate('billing.benefitYoutubeDownloads', { count: download[1] });
  const known = {
    'general speed and ordinary quality': 'benefitStandardQuality',
    'faster and higher quality': 'benefitHigherQuality',
    'unlimited rap name or lyrics generation': 'benefitRap',
    'unlimited lyrics generation': 'benefitLyrics',
    'unlimited voice separation': 'benefitSeparation',
    'free download and share music': 'benefitMusicDownload',
    'ad free': 'benefitAdFree',
    // These catalog translations correspond to Ad Free for the same product IDs.
    '广告免费': 'benefitAdFree',
    '免费广告': 'benefitAdFree',
    '廣告免費': 'benefitAdFree',
    '免費廣告': 'benefitAdFree',
    '광고 무료': 'benefitAdFree',
    'publicité gratuite': 'benefitAdFree',
    'anuncio gratis': 'benefitAdFree',
  };
  const key = Object.hasOwn(known, text.toLowerCase()) ? known[text.toLowerCase()] : undefined;
  return key ? translate('billing.' + key) : text;
}
